import(/* webpackMode: "eager" */ "/home/runner/work/andrew-mccourt-website/andrew-mccourt-website/app/consulting/page.tsx");
